module.exports = __webpack_public_path__ + "static/media/ex4.49ba81d5.jpg";